import web from "../image/web.png";
import app from "../image/app.png";
import swf from "../image/swf.png";
import digital from "../image/digital_marketing.png";
import android from "../image/android.png";
import marketing from "../image/marketing.png";

const serviceData = [
    {
        imgsrc : web,
        title : "Web Development",
    },
    {
        imgsrc : app,
        title : "App Development",
    },
    {
        imgsrc : swf,
        title : "Swofteare Engineer",
    },
    {
        imgsrc : digital,
        title : "Digital Marketing",
    },
    {
        imgsrc : android,
        title : "Android Development",
    },
    {
        imgsrc : marketing,
        title : "Marketing",
    },
]

export default serviceData;